import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'bonusCase',
    standalone: false
})
export class BonusCasePipe implements PipeTransform {
    public transform(count: number): string {
        if (count === null || count === undefined) return '';

        const lastDigit = count % 10;
        const lastTwoDigits = count % 100;

        // Исключения: 11-14 — всегда "бонусов"
        if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
            return 'бонусов';
        }

        // По последней цифре
        switch (lastDigit) {
            case 1:
                return 'бонус';
            case 2:
            case 3:
            case 4:
                return 'бонуса';
            default:
                return 'бонусов';
        }
    }
}
